<template>
  <div v-if="modal.backdrop">
    <div
      class="modal fade"
      :class="modal.open ? 'show' : ''"
      style="display: block"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      @click="$event.target.classList.contains('modal') ? close() : true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ config.title }}</h5>
            <button
              type="button"
              class="close"
              @click="close"
              v-html="loading ? spin() : ic('close')"
            ></button>
          </div>
          <form @submit.prevent="submit">
            <div class="modal-body" ref="modal">
              <div class="row form-group">
                <div class="col-6">
                  <label class="form-label">Id</label>
                  <input type="text" class="form-control" placeholder="Id" v-model="input.id" required>
                </div>
                <div class="col-6">
                  <label class="form-label">Nama</label>
                  <input type="text" class="form-control" placeholder="Nama" v-model="input.name" required>
                </div>
              </div>
            </div>
            <div class="modal-footer pt-2">
              <button type="button" class="btn btn-white" @click="close()" v-html="'Tutup'"></button>
              <button 
                type="submit"
                class="btn btn-primary"
                :disabled="isSubmit"
                v-html="modal.isSubmit ? spin() : 'Simpan'">
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import { mapActions, mapState } from "vuex";

export default {
  name: "FormCreateVendor",
  props: {
    config: {
      view: false,
      title: "Modal Title"
    },
    isSubmit: { default: false },
    status: { default: false }
  },
  mixins: [helper],
  data() {
    return {
      modal: {
        open: false,
        backdrop: false
      },
      selectizeConfig: {
        maxItems: 99,
        plugins: ["remove_button"]
      },
      input: {
        id: null,
        name: null
      }
    };
  },
  computed: {
    ...mapState(["loading"])
  },
  methods: {
    ...mapActions(["getVendorOptimize"]),

    submit() {
      this.$emit("update:isSubmit", true);
      this.$emit("submit", this.input);
    },

    close() {
      this.$emit("update:config", { view: false, title: "Create Vendor" });
    }
  },
  watch: {
    "config.view": function(view) {
      if (view) {
        this.$emit("update:isSubmit", false);
        this.modal.backdrop = view;
        setTimeout(() => {
          this.modal.open = view;
        }, 100);
      } else {
        this.modal.open = view;
        setTimeout(() => {
          this.modal.backdrop = view;
        }, 100);
      }
    },
    status: function(status) {
      if (status) {
        this.input = {};
      }
    }
  }
};
</script>